/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("dx.webapp.register").
controller("DxRegisterRouteController", function registerRouteController(
	$scope,
	$location,

	UIStateManager,
	DX_URLS
) {
	"use strict";

	$scope.state = new UIStateManager("register");

	$scope.$on("auth:registersuccess", function onRegisterSuccess() {
		$location.path(DX_URLS.get("overview"));
	});
});
